import React, { useState } from "react";
import Header from "../components/Header";
import Appfooter from "../components/Appfooter";

const ProtectedLayout = ({ children }) => {
  const [devtoolsOpen] = useState(false);

  return (
    <>
      {devtoolsOpen === false && (
        <div
          onContextMenu={(e) => {
            if (process.env.REACT_APP_ENV !== "development") {
              e.preventDefault();
            }
          }}
        >
          <Header>{children}</Header>
          <Appfooter />
        </div>
      )}
    </>
  );
};

export default ProtectedLayout;
